import { Text } from "@vericus/cadmus-ui";

import { getActiveMembers } from "../../../group/utils";
import { ProjectIssueWithChildren } from "../../types";
import { useProjectManagementTableContext } from "../table/context";
import * as styles from "./styles.css";

export const IssueDetailsTooltip = ({
  data,
}: {
  data: ProjectIssueWithChildren;
}) => {
  const { title, description, dueDate, assignees: issueAssignees } = data;
  const { group } = useProjectManagementTableContext();

  const assigneeName =
    getActiveMembers(group).find((member) => member.id === issueAssignees[0])
      ?.name || "Unassigned";

  return (
    <div className={styles.tooltipContent}>
      <Text as="div" kind="headingFour" className={styles.tooltipTitle}>
        {title}
      </Text>
      <div className={styles.tooltipMetaItem}>
        <p className={styles.tooltipDescription}>
          {description || "No description provided"}
        </p>
      </div>
      <div className={styles.tooltipMeta}>
        <div className={styles.tooltipMetaItem}>
          <div>
            <strong>Assignee:</strong> {assigneeName}
          </div>
        </div>
        <div className={styles.tooltipMetaItem}>
          <div>
            <strong>Due:</strong>{" "}
            {dueDate ? new Date(dueDate).toDateString() : "No due date"}
          </div>
        </div>
      </div>
    </div>
  );
};
